/* import __COLOCATED_TEMPLATE__ from './time-picker.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { convertTimeStringToLocalizedFormat } from '@dashboard/shared-ui/utils/availability/availability-period-utils';
import { inject as service } from '@ember/service';
import { START_TIME_DEFAULT_VALUE, END_TIME_DEFAULT_VALUE } from '@square/dashboard-items-data/models/connect/availability-period/data';
import range from '@square/dashboard-utilities/utils/math/range';
/**
 * This is an IIFE that allows us to cache options in the closure of the outer function
 * This allows us to avoid having to generate options each time this function is called.
 */
const generateTimePickerOptions = function () {
  let cachedOptions = [];
  let cachedLangCode = '';
  return function (languageCode) {
    if (languageCode !== cachedLangCode) {
      // Clear the cached options in case they've already been generated
      cachedOptions = [];
      cachedLangCode = languageCode;
      const Hours = range(24).map(hour => String(hour).padStart(2, '0')); // ["00", "01", "02", "03" ... "23"]
      const Minutes = ['00', '15', '30', '45']; // 15 minute increments

      for (const hour of Hours) {
        for (const minute of Minutes) {
          const value = `${hour}:${minute}:00`;
          cachedOptions.push({
            label: convertTimeStringToLocalizedFormat(languageCode, value),
            value
          });
        }
      }
    }
    return cachedOptions;
  };
}();
let TimePicker = (_class = class TimePicker extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  get options() {
    return generateTimePickerOptions(this.intl.primaryLocale);
  }
  get defaultOption() {
    const defaultTime = this.args.defaultLocalTime ?? (this.args.isStart ? START_TIME_DEFAULT_VALUE : END_TIME_DEFAULT_VALUE);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.options.find(option => option.value === defaultTime);
  }
  get currentOption() {
    if (!this.args.selectedTime) {
      return this.defaultOption;
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.options.find(option => option.value === this.args.selectedTime);
  }
  get placeholderText() {
    if (this.args.isStart) {
      return this.intl.t('sharedUi.availability.period.placeholder.startTime');
    }
    return this.intl.t('sharedUi.availability.period.placeholder.endTime');
  }
  timeChanged(newOption) {
    this.args.onTimeChange({
      value: newOption.value,
      isStart: this.args.isStart
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "timeChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "timeChanged"), _class.prototype)), _class);
export { TimePicker as default };